













import { mapActions } from 'vuex';
import { GPageBase } from '@/mixins';
import { required } from 'vuelidate/lib/validators';
import Component, { mixins } from 'vue-class-component';
import GVTag from '@/components/GVTag.vue';
import { Constants } from '@/constants/constants';
import { SocialLoginDef } from '@/constants/socialLoginDef';

@Component({
  name: 'GOAuthCallback',
  components: {
    GVTag,
  },
  methods: {
    ...mapActions(['handleBackToHome']),
  },
  validations: {
    email: { required },
    form: ['email'],
  },
})
export default class GOAuthCallback extends mixins(GPageBase) {
  oauthProgress: boolean = false;
  async beforeCreate() {
    // OAuth コールバック時
    const route = this.$route;
    if (route.path === '/oauth/callback') {
      this.oauthProgress = true;
      const code = route.query.code;
      const state = route.query.state;
      // state を key に、provider(google, microsoft, etc...) を取得
      const provider = sessionStorage.getItem(`oauth:${state}`);
      // 取得後に不要なので削除
      sessionStorage.removeItem(`oauth:${state}`);

      // sessionStorage に state を key にした provider が存在しなければ不正なので signin に戻す
      if (!provider) {
        return window.location.replace('/signin');
      }
      // "google" or "microsoft" でなければ不正なので signin に戻す
      if (provider !== SocialLoginDef.Google && provider !== SocialLoginDef.Microsoft) {
        return window.location.replace('/signin');
      }

      // code & state 双方存在しない（片方でも存在しない）場合は不正なので signin に戻す
      if (typeof code !== 'string' || typeof state !== 'string') {
        return window.location.replace('/signin');
      }

      await this.$store.dispatch('signin/signinOAuth', {code: code, provider: provider});
    }
  }

  get isJgrow(): boolean {
    return process.env.VUE_APP_SERVICE_NAME === Constants.ServiceNameJgrow;
  }

  handleBackToLogin() {
    this.$router.push(`/signin`);
  }
}
